/**
 * Image Slicer
 *
 * Chop chop?
 * Chop chop!
 *
 * One Chop Shop
 *
 * Don't hop
 * Just chop
 *
 * And the tomato said to the carrot,
 * chop chop! And the onion said to the
 * potato, chop chop!
 *
 * And then...
 *
 */

import 'regenerator-runtime/runtime';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AuthProvider } from './auth/AuthContext';

const container = document.getElementById('main');
if (container) {
  const root = createRoot(container);
  root.render(
    <AuthProvider>
      <App />
    </AuthProvider>
  );
} else {
  console.error('Failed to find the root element');
}
